import { useGetAffiliationStatus as useGeneratedGetAffiliationStatus } from "@/api/generated";
import type {
  AffiliationStatusResponse,
  AffiliationStatusResult,
} from "@/api/generated/models";
import { useAuthStore } from "@/store";
import { isMembershipPartner } from "@/utils/partner";

export type AffiliationStatusWithMembership = AffiliationStatusResponse & {
  membershipAffiliation?: AffiliationStatusResult;
  membershipPartnerName?: string | null;
};

const withMembershipAffiliation = (
  status: AffiliationStatusResponse,
): AffiliationStatusWithMembership => {
  // we currently have no concrete definition for the behavior when there are multiple affiliations,
  // so we just use the first one. Should be a very rare case until we put in the work to define.
  const membershipAffiliation = status.results?.find(
    (result) => result.partner_uid && isMembershipPartner(result.partner_uid),
  );

  return {
    ...status,
    membershipAffiliation,
    membershipPartnerName: membershipAffiliation?.partner_name ?? null,
  };
};

export const useGetAffiliationStatus = (enabled = true) => {
  const { isAuthInitialized } = useAuthStore();

  return useGeneratedGetAffiliationStatus<AffiliationStatusWithMembership>({
    query: {
      enabled: isAuthInitialized && enabled,
      select: withMembershipAffiliation,
      staleTime: 5 * 60 * 1000,
    },
  });
};
